import { Container, Image } from './styles'

type Props = {
  position?: string
  top?: number
  left?: number
  onClose?: () => void
  color?: string
}

const GCloseButton = ({ position, top, left, onClose, color }: Props) => {
  return (
    <Container onClick={onClose}>
      <Image
        position={position}
        top={top}
        left={left}
        height={19}
        width={19}
        stroke={color}
        alt="Fechar"
      />
    </Container>
  )
}

export default GCloseButton
